import React, { useState, useEffect } from "react";
import { PaymentElement, Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";

const StripePayment = ({ registrationID }) => {
  const stripe = useStripe();
  const elements = useElements();

  // Set up the base URL for server requests
  const baseUrl = window.location.origin + window.location.pathname;

  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (elements == null) {
      return;
    }

    try {
      // Post data to the server to create a Stripe PaymentIntent

      // Trigger form validation and wallet collection
      const { error: submitError } = await elements.submit();

      if (submitError) {
        console.error("elements.submit()".submitError);
        throw new Error(`Payment info validation error: ${submitError.message}`);
      }

      // Create the PaymentIntent and obtain clientSecret from your server endpoint
      const response = await fetch(`${baseUrl}/createStripePaymentIntent`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ registrationID: registrationID }),
      });

      console.log("createStripePaymentIntent", response);

      if (!response.ok) {
        console.error("createStripePaymentIntent", response);
        throw new Error(`Payment intent error: ${response.status} ${response.statusText}`);
      }

      const body = await response.json();
      const { clientSecret } = body;

      const returnUrl = new URL(`${baseUrl}/savePayment`);
      returnUrl.searchParams.append("registrationID", registrationID);

      const { error: confirmationError } = await stripe.confirmPayment({
        //`Elements` instance that was used to create the Payment Element
        elements,
        clientSecret,
        confirmParams: {
          return_url: returnUrl.toString(),
        },
      });

      if (confirmationError) {
        console.error("stripe.confirmPayment()", confirmationError);
        throw new Error(`Error confirming payment: ${confirmationError.message}`);
      } else {
        // Your customer will be redirected to your `return_url`. For some payment
        // methods like iDEAL, your customer will be redirected to an intermediate
        // site first to authorize the payment, then redirected to the `return_url`.
      }
    } catch (err) {
      console.error("An error occurred during the payment process:", err);
      setErrorMessage("An error occurred during the payment process:", err);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement
        options={{
          paymentMethodOrder: ["card"],
          paymentMethodConfiguration: {
            googlePay: "never",
            applePay: "never",
            payLater: "never",
          },
          fields: {
            billingDetails: {
              address: {
                // country: "never",
              },
            },
          },
          wallets: {
            link: "never", // Explicitly disable Link
          },
          linkAuthenticationElement: {
            mode: "disabled", // Removes the Link promotion banner
          },
        }}
      />
      <button
        type="submit"
        disabled={!stripe || !elements}
        className={`c-event-registration-form__button c-event-registration-form__button-pay${!stripe || !elements ? " c-event-registration-form__button--disabled" : ""}`}
      >
        Pay
      </button>
      {/* Show error message to your customers */}
      {errorMessage && <div>{errorMessage}</div>}
    </form>
  );
};

export default StripePayment;
